const features = [
  {
    icon: "travel_explore",
    title: "Multi-Engine Coverage",
    description:
      "We evaluate your website against the ranking criteria of Google, ChatGPT, Gemini, Perplexity, and Claude — not just traditional search engines.",
  },
  {
    icon: "verified_user",
    title: "Trust Signal Scoring",
    description:
      "AI models weigh credibility signals differently than Google. We audit the specific factors — reviews, structured data, brand mentions — that determine whether an LLM recommends you.",
  },
  {
    icon: "auto_fix_high",
    title: "AI-Ready Recommendations",
    description:
      "Every recommendation includes an implementation guide and AI-generated code snippets, so your team can ship fixes without guesswork.",
  },
];

const FeatureEditorial = () => {
  return (
    <section className="py-32 px-8">
      <div className="max-w-8xl mx-auto flex flex-col lg:flex-row gap-24 items-center">
        {/* Image */}
        <div className="lg:w-1/2 order-2 lg:order-1">
          <div className="relative">
            <img
              src="/feature_editorial.jpg"
              alt="Professional laptop screen showing technical SEO charts and analytics"
              className="rounded-[3rem] shadow-2xl w-full"
              loading="lazy"
              width={800}
              height={600}
            />
            <div className="absolute -top-12 -left-12 w-48 h-48 bg-primary/5 rounded-full blur-3xl" />
            <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-tertiary/5 rounded-full blur-3xl" />
          </div>
        </div>

        {/* Content */}
        <div className="lg:w-1/2 order-1 lg:order-2">
          <h2 className="font-headline text-4xl lg:text-5xl font-extrabold mb-8 leading-tight">
            Built for Hotels That <br />
            <span className="text-primary">Compete on Visibility.</span>
          </h2>

          <div className="space-y-8">
            {features.map((feature) => (
              <div key={feature.title} className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-xl bg-surface-container-high">
                  <span className="material-symbols-outlined text-primary">{feature.icon}</span>
                </div>
                <div>
                  <h4 className="font-headline text-xl font-bold mb-2">{feature.title}</h4>
                  <p className="text-on-surface-variant">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureEditorial;
